export default {
	lang:'en',
	nav: {
		"nav_lang_zh": '中文（简体）',
		"nav_lang_en": 'English',
		"nav_lang_tw": '中文（繁體）',
		"nav_lang_ja": '日本語',
		"nav_lang_ko": '한국어',
		"nav_lang_de": 'Deutsch',
		"nav_lang_fr": 'Français',
		"nav_lang_th": 'ภาษาไทย',
		"nav_lang_it": 'Italiano',
		"nav_lang_es": 'Español',
		"nav_lang_ru": 'Русский',
		"nav": 'VORMOR AI',
		"nav2": 'Account security',
		"nav3": 'My Cloud disk',
		"nav4": 'Login out',
		"nav5": 'Login',
		"nav6": 'Cloud space',
		"nav7": 'ChatGPT Large Model',
		"nav8": 'Intelligent My Cloud disk Space System',
		"nav_phone_number_code": 'Mobile phone number',
		"nav_update": 'Replace',
		"nav_bind": 'Bind',
		"nav_phone_code_tips": "To confirm that it is you performing the operation, please complete identity verification using the phone verification code.",
		"nav_phone_number": 'Phone number',
		"nav_phone_number_verify": 'Switch to phone number verification',
		"nav_phone_email_verify": 'Switch to Email Verification',
		"nav_set_phone_number": 'Set new phone number',
		"nav_verify_login": 'Verify Login',
		"nav_phone_email": 'Email/Phone Number',
		"nav_phone_login": 'Phone verification login',
		"nav_email_login": 'Email verification login',
		"nav_email_fail": 'Email format error, please re-enter',
		"nav_pw_fail": 'Password format error, please re-enter',
		"nav_code_fail": 'Incorrect verification code',
		"nav_phone_fail": 'The phone number format is incorrect. Please re-enter.',
		"nav_input_fail": 'Please enter your email',
		"nav_input_phone": 'Please enter your phone number',
		"nav_phone_verify_back": 'Phone verification to retrieve',
		"nav_email_verify_back": 'Email verification to retrieve'
	},
	login:{
		"login1":'Password login',
		"login2":'SMS login',
		"loginTab3":'Email login',
		"login3":'Email',
		"login4":'Login password',
		"login5":'Mobile phone number',
		"login6":'Please select',
		"login7":'Mobile verification code',
		"login8":'Login',
		"login9":'Forgot password',
		"login10":'register',
		"login11":'By logging in, you agree to',
		"login12":'Service',
		"login13":'Privacy',
		"login14":'get code',
		"login15":'CN',
		"login16":'Please enter your account number',
		"login17":'Please enter password',
		"login18":'Login successful!!',
		"login19":'Please enter the verification code!',
		"login20":'Sent successfully!',
		"login21":'and',
		
		"login22":'Recording Cloud',
		"login23":'My Writing',
		"login24":'My conversation',
		"login25":'Account security',
		"login26":'Login out',
		
		"login27":'Email password retrieval',
		"login28":'Mailbox',
		"login29":'Email verification code',
		"login30":'Set login password (6-16 characters)',
		"login31":'Enter login password again',
		"login32":'Submit',
		"login33":'Return to login',
		"login34":'Modified successfully!',
	},
	register:{
		"register1":'Phone',
		"register2":'Please enter your phone number',
		"register3":'Please select',
		"register4":'Mobile code',
		"register5":'Password',
		"register6":'Please enter the verification code',
		"register7":'6-16 characters',
		"register8":'pwdConfirm',
		"register9":'Email',
		"register10":'Please enter your email address',
		"register11":'Code',
		"register12":'Please enter the verification code',
		"register13":'I have read and agree',
		"register14":'Please read and check the agree agreement',
		"register15":'Phone number format error/phone number registered',
		"register16":'Mobile verification code error',
		"register17":'Please enter email/email format error',
		"register18":'Email format error',
		"register19":'Email verification code error',
		"register20":'Please set the password to 6-16 characters',
		"register21":'Password format error',
		"register22":'The passwords entered twice are inconsistent',
		"register23":'Please enter password',
		"register24":'registered successfully',
		"register25":'Verification code error',
	},
	recorder:{
		"recorder1":'Recording Cloud',
		"recorder2":'Cloud space capacity',
		"recorder3":'Files',
		"recorder331":'Recycle Bin',
		"recorder332":'Deleted All',
		"recorder4":'name',
		"recorder5":'Audio duration',
		"recorder6":'file size',
		"recorder7":'Creation time',
		"recorder8":'operation',
		"recorder9":'Cloud Space Description',
		"recorder10":'File',
		"recorder11":'OCR files',
		"recorder12":'1. Cloud Space Usage',
		"recorder13":'After saving recordings and handwritten notes on your smart office notebook or recording pen, you can upload them to the cloud drive. Even if your smart device is not nearby, you can enter the cloud space to view the note files.',
		"recorder14":'2. How to upload cloud space?',
		"recorder15":'Recording Pen: Go to the device "My Files" ->click on batch operation ->click on "Upload" to add the file to the cloud upload queue and upload it to the cloud space. ',
		"recorder16":'Smart Office Notebook:',
		"recorder17":'Method 1: Long press in the note list, select the notes that need to be uploaded in bulk, and then click" Sync "to complete the upload.',
		"recorder171":'Method 2: Open the details page of a single note and click on "More - Sync" to upload the note to the cloud space.',
		"recorder18":'Untransferred',
		"recorder19":'View Summary',
		"recorder20":'Speaker',
		"recorder21":'Editors Speaker Name',
		"recorder22":'confirm',
		"recorder23":'download',
		"recorder24":'Download content:',
		"recorder25":'Download settings:',
		"recorder26":'Show Speaker',
		"recorder27":'cancel',
		"recorder28":'Link sharing',
		"recorder29":'Anyone who obtains the link can access it, only reading is supported, and the link is valid for 7 days',
		"recorder30":'Copy Link',
		"recorder31":'Scan for quick access',
		"recorder32":'Intelligent organization',
		"recorder33":'Distinguishing speakers',
		"recorder34":'Intelligent differentiation of transcribed text based on the speakers role',
		"recorder35":'Intelligent spoken language regulation',
		"recorder36":'Automatically filter modal particles, repeating words, and pausing words',
		"recorder37":'Non human voice filtering',
		"recorder38":'Automatically skip audio without human voice or noise during playback',
		"recorder39":'Please select',
		"recorder40":'Document',
		"recorder41":'audio frequency',
		"recorder42":'Document+Audio',
		"recorder43":'Tips',
		"recorder44":'This operation will delete the file. Do you want to continue?',
		"recorder441":'This operation will delete all file. Do you want to continue?',
		"recorder45":'Confirm',
		"recorder46":'Cancel',
		"recorder47":'Deleted successfully!',
		"recorder48":'Undeleted',
		"recorder49":'No tags yet',
		"recorder50":'Saving',
		"recorder51":'Recycle Bin',
	},
	personal:{
		"personal1":'Account settings',
		"personal2":'personal information',
		"personal3":'Avatar',
		"personal4":'Upload files',
		"personal5":'Supports JPG, JPEG, GIF, PNG styles, and images up to 2M in size',
		"personal6":'nickname',
		"personal7":'Please enter your nickname',
		"personal8":'Gender',
		"personal9":'gentleman',
		"personal10":'lady',
		"personal11":'secrecy',
		
		"personal12":'birthday',
		"personal13":'Please select your birthday',
		"personal14":'occupation',
		"personal15":'Please choose a profession',
		"personal16":'Please enter occupation (not mandatory)',
		"personal17":'Country',
		"personal18":'Please select a country',
		"personal19":'preserve',
		"personal20":'personal information',
		"personal21":'Account security',
		"personal22":'Only supports images up to 2M in size',
		"personal23":'Upload successful!',
		"personal24":'Modified successfully!',
		
		"personal25":'Account security',
		"personal26":'password',
		"personal27":'modify',
		"personal28":'E-mail',
		"personal29":'replace',
		"personal30":'Account cancellation',
		"personal32":'Are you sure to cancel your account?',
		"personal33":'After logging out, all content in your account will be cleared. Please operate with caution.',
		"personal34":'cancel',
		"personal35":'confirm',
		"personal36":'Identity verification',
		"personal37":'To confirm that it was your own operation, please complete the identity verification through the email verification code',
		"personal38":'mailbox',
		"personal39":'code',
		"personal40":'Please enter the code',
		"personal41":'Next step',
		"personal42":'Set up a new email',
		"personal43":'mailbox',
		"personal44":'Please enter a new email address',
		"personal45":'code',
		"personal46":'Please enter the code',
		"personal47":'confirm',
		"personal48":'Set a new login password',
		"personal49":'password',
		"personal50":'Please enter a new password',
		"personal51":'Confirm password',
		"personal52":'Please enter the new password again',
		"personal53":'confirm',
		"personal54":'get code',
		
		"personal55":'Email format error',
		"personal56":'Replacement successful!',
		"personal57":'Please set the password to 6-16 characters',
		"personal58":'The passwords entered twice are inconsistent',
		"personal59":'Modified successfully!',
		"personal60":'Logout successful',
		"share_url": "Link Sharing",
		"share_url_7_day": "The sharing link is valid for 7 days. Before it expires, anyone who gets the link can access it.",
		"share_audio": "Audio Recording",
		"share_trans_text": "Transcription",
		"share_summny_text": "Summary",
		"share_map": "Mind Map",
		"share_url_pw": "Access Encryption",
		"share_random_pw": "Password Randomly Generated",
		"share_url_copy": "Copy Link",
		"share_url_copy_success": "Copy link successfully",
		"share_link_pw": "Access Password",
		"share_copy_success": "The transcription has been copied to the clipboard!",
		"share_copy_success2": "Zusammenfassung in die Zwischenablage kopiert!",
		"share_speaker": "Speaker",
		"share_no_update_speaker": "Cannot edit Speaker is empty",
		"share_no_trans":"No transcribed text",
		"share_no_summny":"No summary text",
		"share_no_map":"No map content",
		"share_trans_text_1": "Transfer",
		"share_summny_text_1": "Summary",
		"share_map_1": "Map",
		"share_save": "Saved successfully",
		"share_no_map":"Map image not generated",
		"share_update_text2": "Edit summary text",
		"showLoading": "loading...",
		"handwriting": "Handwritten content",
		"handwritingText": "Handwriting",
		"share_1": "Handwriting content on this page is not recognized",
		"share_2": "Edit handwriting recognition",
		"share_3": "Handwriting recognition",
		"share_4":"Exporting file, please do not leave this page",
		"folder_text":"Folder",
		"folder_text_update_name":"Rename",
		"folder_text_del":"Delete",
		"folder_text_all":"All",
		"folder_text_type":"File type",
		"folder_text_audio":"Audio notes",
		"folder_text_writing":"Handwritten notes",
		"folder_text_file_type":"File type",
		"folder_text_add":"Create a new folder",
		"folder_text_input_name":"Please enter a name",
		"folder_text_cancel":"Cancel",
		"folder_text_summit":"Confirm",
		"folder_text_name_not_null":"Name cannot be empty",
		"folder_text_add_success":"Created successfully!",
		"folder_text_del_confirm":"Delete confirmed",
		"folder_text_confirm":"Are you sure you want to delete the selected folder? The notes in the folder will be moved to the recycle bin after deletion.",
		"folder_text_del_success":"Deleted successfully!",
		"folder_text_move":"Moved to",
		"folder_text_move_success":"Moved successfully!",
		"folder_update_name":"Renamed the folder",
		"folder_text_update_success":"Modified successfully!",
		"empty_text":"No data available.",
		"trans_text_null":"The transcribed text cannot be empty",
		"summary_text_null":"The summary cannot be empty",
		"please_create_folder":"Please create a folder first"
	}
}